import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { getPlacementTest } from 'src/api';
import styles from './PlacementTest.module.sass';

export const PlacementTest = () => {
  const isLogged = useSelector((state) => state.get('header')?.get('isLogged')) || false;
  const schoolId = useSelector((state) => state.get('school')?.get('id')) || 0;
  const [testContent, setTestContent] = useState({});
  const { t } = useTranslation();
  const isEnglishAcademy = schoolId === 8387;

  useEffect(() => {
    if (isLogged && isEnglishAcademy) {
      const EnglishAcademySlug = 'ingles';

      getPlacementTest(EnglishAcademySlug)
        .then((res) => setTestContent(res?.data))
        .catch((err) => {
          throw new Error('::ERROR::PLACEMENT_TEST', { cause: err });
        });
    }
  }, [isLogged, isEnglishAcademy]);

  if (!testContent?.showPlacementTest) return null;

  return (
    <div className={styles.PlacementTest}>
      <div className="u-wrapper">
        <div className={styles.Content}>
          <div className={styles.Message}>
            <div className={testContent?.testTaken ? styles.Taken : styles.Take}>
              <span>
                <FontAwesomeIcon icon={faClipboardCheck} />
              </span>
              {testContent?.testTaken ? (
                <p
                  dangerouslySetInnerHTML={{ __html: t('escuela.placementTest.taken', { level: testContent?.level }) }}
                />
              ) : (
                <p dangerouslySetInnerHTML={{ __html: t('escuela.placementTest.take') }} />
              )}
            </div>
          </div>
          <a href={testContent?.url}>
            {testContent?.testTaken ? t('escuela.placementTest.takenCTA') : t('escuela.placementTest.takeCTA')}
            <FontAwesomeIcon icon={faChevronRight} />
          </a>
        </div>
      </div>
    </div>
  );
};
